import { Parallax } from 'ng2-parallax/commonjs';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.less'],
})
export class HomeComponent implements OnInit {

  public threeSixtyPics = [
    '/assets/img/quality/epic/epic1.jpg',
    '/assets/img/quality/epic/epic2.jpg',
    '/assets/img/quality/epic/epic3.jpg',
    '/assets/img/quality/epic/epic4.jpg',
    '/assets/img/quality/epic/epic5.jpg',
    '/assets/img/quality/epic/epic6.jpg',
    '/assets/img/quality/epic/epic7.jpg',
    '/assets/img/quality/epic/epic8.jpg',
    '/assets/img/quality/epic/epic9.jpg',
    '/assets/img/quality/epic/epic10.jpg',
    '/assets/img/quality/epic/epic11.jpg',
    '/assets/img/quality/epic/epic12.jpg',
    '/assets/img/quality/epic/epic13.jpg',
    '/assets/img/quality/epic/epic14.jpg',
    '/assets/img/quality/epic/epic15.jpg',
    '/assets/img/quality/epic/epic16.jpg',
    
            
  ];

  images: Array<any> = [
    { "sType": "img", "imgSrc": "/assets/img/gallery/Nurgle1header.jpg" },
    { "sType": "img", "imgSrc": "/assets/img/gallery/Nurgle2header.jpg" },
    { "sType": "img", "imgSrc": "/assets/img/gallery/Nurgle3header.jpg" },
    { "sType": "img", "imgSrc": "/assets/img/gallery/Nurgle4header.jpg" },
    { "sType": "img", "imgSrc": "/assets/img/gallery/Nurgle5header.jpg" },
    /*{ "sType": "div", "content": "<div>...Hello It's slidable content<div>" }*/];

  public threeSixtyOpen = false;
  public compareSliderOpen = false;

  constructor() { }

  ngOnInit() {
  }

  public openThreeSixty(): void {
    this.threeSixtyOpen = true;
  }

  public openCompareSlider(): void {
    this.compareSliderOpen = true;
  }

  public closeCompareSlider(event: any): void {
    if(event.target.id === "compareSliderOverlay"){
      this.compareSliderOpen = false;
    }
  }

  public closeThreeSixty(event: any): void {
    if(event.target.id === "threeSixtyOverlay"){
      this.threeSixtyOpen = false;
    }
  }

}



// WEBPACK FOOTER //
// /home/artur/workspace/vscode/warpriders/src/app/content/home/home.component.ts